import { useContext } from 'react';
import { RightDrawerContext } from './RightDrawerContext';
export const useRightDrawerContext = () => {
  const context = useContext(RightDrawerContext);
  if (context === undefined) {
    throw new Error('useRightDrawer must be used within a useRightDrawerProvider');
  }
  return context;
};